module.exports = __webpack_public_path__ + "img/architectural-evolution-3.37e277fa.png";